 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		7: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "sports2-static/chunk." + ({"0":"source~/esports-betting-rules-TR~bet-builder-rules-DE~bet-builder-rules-EN~bet-builder-rules-ES~bet-~078fb09e","1":"source~/esports-betting-rules-TR~bet-builder-rules-DE~bet-builder-rules-EN~bet-builder-rules-ES~bet-~e20a97ce","2":"source~/esports-betting-rules-TR~esports-betting-rules-DA~esports-betting-rules-DE~esports-betting-r~11b5dbfd","5":"source~virtual-esports-betting-rules-EN~virtual-esports-betting-rules-IT~virtual-esports-betting-rul~c400071f","8":"source~i18n-widgets-ar-json","9":"source~i18n-widgets-en-json","12":"source~/esports-betting-rules-TR","13":"source~bet-builder-rules-DE","14":"source~bet-builder-rules-EN","15":"source~bet-builder-rules-ES","16":"source~bet-builder-rules-ES-MX","17":"source~bet-builder-rules-ET","18":"source~bet-builder-rules-FI","19":"source~bet-builder-rules-FR","20":"source~bet-builder-rules-IT","21":"source~bet-builder-rules-JA","22":"source~bet-builder-rules-KA","23":"source~bet-builder-rules-LT","24":"source~bet-builder-rules-LV","25":"source~bet-builder-rules-PL","26":"source~bet-builder-rules-PT-BR","27":"source~bet-builder-rules-RO","28":"source~bet-builder-rules-RU","29":"source~bet-builder-rules-SQ","30":"source~bet-builder-rules-TR","31":"source~bet-details-page","32":"source~betting-history-container","33":"source~betting-history-page","34":"source~betting-rules-DA","35":"source~betting-rules-DE","36":"source~betting-rules-EN","37":"source~betting-rules-ES","38":"source~betting-rules-ES-MX","39":"source~betting-rules-FR","40":"source~betting-rules-IT","41":"source~betting-rules-JA","42":"source~betting-rules-PL","43":"source~betting-rules-PT","44":"source~betting-rules-PT-BR","45":"source~betting-rules-RO","46":"source~betting-rules-RU","47":"source~betting-rules-SQ","48":"source~betting-rules-TR","49":"source~bonus-info","50":"source~cashout-terms-AR","51":"source~cashout-terms-DA","52":"source~cashout-terms-DE","53":"source~cashout-terms-EN","54":"source~cashout-terms-ES","55":"source~cashout-terms-ES-MX","56":"source~cashout-terms-ET","57":"source~cashout-terms-FI","58":"source~cashout-terms-FR","59":"source~cashout-terms-IT","60":"source~cashout-terms-JA","61":"source~cashout-terms-KA","62":"source~cashout-terms-KU","63":"source~cashout-terms-LT","64":"source~cashout-terms-LV","65":"source~cashout-terms-PL","66":"source~cashout-terms-PT","67":"source~cashout-terms-PT-BR","68":"source~cashout-terms-RO","69":"source~cashout-terms-RU","70":"source~cashout-terms-SQ","71":"source~cashout-terms-SR","72":"source~cashout-terms-TR","73":"source~esports-betting-rules-DA","74":"source~esports-betting-rules-DE","75":"source~esports-betting-rules-EN","76":"source~esports-betting-rules-ES","77":"source~esports-betting-rules-ES-MX","78":"source~esports-betting-rules-ET","79":"source~esports-betting-rules-FI","80":"source~esports-betting-rules-FR","81":"source~esports-betting-rules-IT","82":"source~esports-betting-rules-JA","83":"source~esports-betting-rules-KA","84":"source~esports-betting-rules-LT","85":"source~esports-betting-rules-LV","86":"source~esports-betting-rules-PL","87":"source~esports-betting-rules-PT","88":"source~esports-betting-rules-PT-BR","89":"source~esports-betting-rules-RO","90":"source~esports-betting-rules-RU","91":"source~esports-betting-rules-SQ","92":"source~esports-betting-rules-SR","94":"source~generated-mappings","95":"source~i18n-ar-json","96":"source~i18n-en-json","98":"source~settings-page","99":"source~streaming-carousel","100":"source~virtual-esports-betting-rules-EN","101":"source~virtual-esports-betting-rules-IT","102":"source~virtual-esports-betting-rules-JA","103":"source~virtual-esports-betting-rules-PL","105":"vendors~rc-slider","106":"vendors~react-google-recaptcha","107":"vendors~streaming-carousel"}[chunkId]||chunkId) + "." + {"0":"ac0074c53614f85b79eb","1":"7ba1b2a8a93eac19e1cb","2":"d6603f7f6b88959e2039","3":"613d5400f23dd92e89da","4":"d4e9729ec23a00cd9d56","5":"d4c04d17335068f9860c","6":"8a88da112a25cfebe058","8":"e7cdc84c3cef206fc0b8","9":"bf6b90c21e5a0bb19938","12":"a4fb02715f7c7143c8da","13":"a1c0d59e69b792adf12e","14":"fa509b172ac085ef2d18","15":"dec4ea54a499cbb1f986","16":"de801fe66d9b98f4b086","17":"f6f431564e89e79f889a","18":"ff90e4af33087c5424dc","19":"088f537ad8b8c17f99a0","20":"13e4b0ea839bb68670d6","21":"d3686710567098eb8bd7","22":"ff644eb549d272f07fb7","23":"38e0741428a37dd1b8c6","24":"b843b79e15dbc8e54b12","25":"190367874dacb402fb48","26":"b95a53ab9a17439705c1","27":"535f73d22965fa87454f","28":"fd693829d5ce6343f3a5","29":"dcfdb0f65acbcec1e8b4","30":"0c101f569392fe6e07d8","31":"ae041400303ea336d2e7","32":"f21474cc1829d9eb1de3","33":"a3ef2f91852f422f4b5e","34":"65e84992c4d2fa8d053a","35":"0b2e8608c5990ad14fa3","36":"6903c4e3a3997a5b91a6","37":"c61ad6e494e9fa478706","38":"dbcbfcf2d84e1de77b35","39":"d97074641caacb3cf441","40":"e45db83e754dcd0830a7","41":"605c6af3849703e90621","42":"40124cc3776784fd4845","43":"9d60c33b4826703de3bc","44":"0d2fd2d2ef3112646dd3","45":"81bfd4fcaa27c3ad2c50","46":"66ff6f1e39df50bb71c5","47":"ee66e7dfb135b11aebe4","48":"f23d98f8726bf4303a59","49":"d7cf259273620166ae6c","50":"44d2220f6007e38a97e8","51":"eca1b14e6d858ea91dbc","52":"9f09e64f4682427d401a","53":"5703a4c2abeb9de94d2a","54":"31aa4720329ac6ebc298","55":"75b59ec527b947dbd247","56":"d303ea79cecc7659ce7b","57":"55bd92a4b6a899580724","58":"4014853fb0f72d5bb354","59":"678e9ad967e943e5235e","60":"56c5ff9048c9dc334a1d","61":"f9950cc27ab52e3b409b","62":"f429ebbe52dd87386d9d","63":"29ca8f2f95dcad7242b9","64":"84a58d799c62cc47f572","65":"bd0b0640240faffde5c8","66":"9e255508d9a3dccfe9fe","67":"45ac8c415a38f3a36780","68":"5cd0ee9520fb89beeee7","69":"f28a2d056c962992c962","70":"01c3bff22b36af6004b2","71":"fc6059bab7f0d6de5027","72":"d7561b7af44f68f90917","73":"b77e240c05f58399ab22","74":"b5208ae492ae61cb0e7a","75":"f8e295bd2dc94df2c3c3","76":"28bd6eca5ee0808dfd54","77":"983670d81190fc1cc00c","78":"a17f0fb5a4d2480efe11","79":"01c48d0a9dca210ad00c","80":"21dc120efee916bbf43b","81":"2a6048e7c7f16808a05d","82":"99738615c820d0a675bb","83":"e73c4c8c0c317b197986","84":"69dfe439b40dffedf4d3","85":"a2c23cda1662a7bea192","86":"3be19212e6dfd7d00473","87":"76025ac49a525c878f97","88":"4aa8c328fea20c399ac6","89":"42cffedfeaabc455431c","90":"13553609cc343f81c77f","91":"89092e6d417dca020f92","92":"c01f8b6e2ef1bb54e358","94":"855d007519482b7f9495","95":"b887cd1e5fccbd3fbd6a","96":"0aed7691f8aa13b46b0f","98":"a898c25adbb3bbff8358","99":"b4906beab6306e78d2f3","100":"4e290ef4c88c2cafc670","101":"8fe10dac06312d11438f","102":"be93e660baa690851421","103":"951dc146566e8d33fb7a","105":"68d3e98658bbfc4ada9a","106":"ff7bc1a7dc6ee9726e45","107":"4aca698f47d0a0d542c6","108":"91bd2ea1440678a5731b","109":"fc9aac9f9248700fcddf","110":"bb854fa43f9d4532adf6","111":"cd6174410700032a0463","112":"89e87c32d38d6e56e32a","113":"93da1a6172268b5bd7b9","114":"08f051e135c1247fa323","115":"bdd9909f9f2f151c04e7","116":"0d43a05ee4e1989170e2","117":"3f7fcfee5675ed28b039","118":"ef02c6c1fc3ac9b49ffb","119":"ba606af24e755a935014","120":"d9846fbeed3466bea831","121":"5d59a74185eb2393e006","122":"724dcd1d01875bfedd54","123":"6ce73fdbfd652e7cc44a","124":"77f5f2e7aecdffa8145e","125":"033077fdcc428cfdc80b","126":"f09df628cb3f5de49cb8","127":"8fe68593f0124da736e3"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonpOMFE2_App"] = window["webpackJsonpOMFE2_App"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
